import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../shared/shared.module';
import { AccountRecipientComponent } from './components/account-recipient/account-recipient.component';
import { BeneficiaryBookComponent } from './components/beneficiary-book/beneficiary-book.component';
import { AccountDetailComponent } from './components/account-recipient/components/account-list/account-detail/account-detail.component';
import { AccountListComponent } from './components/account-recipient/components/account-list/account-list.component';
import { AccountComponent } from './components/account-recipient/components/account-list/account/account.component';
import { DialogBeneficiariosComponent } from './components/account-recipient/components/account-list/dialog-beneficiarios/dialog-beneficiarios.component';
import { AccountsComponent } from './components/accounts/accounts.component';
import { AddWithdrawAccountsComponent } from './components/add-withdraw-accounts/add-withdraw-accounts.component';
import { AdminRateComponent } from './components/admin-rate/admin-rate.component';
import { BinanceRateComponent } from './components/admin-rate/binance-rate/binance-rate.component';
import { CbpayComponent } from './components/admin-rate/cbpay/cbpay.component';
import { ManualRateComponent } from './components/admin-rate/manual-rate/manual-rate.component';
import { SetValuesComponent } from './components/admin-rate/manual-rate/set-values/set-values.component';
import { AdminTransactionsComponent } from './components/admin-transactions/admin-transactions.component';
import { AssignTransactionComponent } from './components/admin-transactions/assign-transaction/assign-transaction.component';
import { AdminWalletsComponent } from './components/admin-wallets/admin-wallets.component';
import { AdminWhatsappOtpComponent } from './components/admin-whatsapp-otp/admin-whatsapp-otp.component';
import { AdminWithdrawalsUsdtComponent } from './components/admin-withdrawals-usdt/admin-withdrawals-usdt.component';
import { BinanceSearchByWalletComponent } from './components/binance-search-by-wallet/binance-search-by-wallet.component';
import { ValidarWalletComponent } from './components/validar-wallet/validar-wallet.component';
import { AssignTrxDialogComponent } from './components/assign-trx-dialog/assign-trx-dialog.component';
import { DepositosRetenidosDialogComponent } from './components/depositos-retenidos-dialog/depositos-retenidos-dialog.component';
import { AssignedTransactionsCriptoComponent } from './components/assigned-transactions-cripto/assigned-transactions-cripto.component';
import { EditCriptoTransactionComponent } from './components/assigned-transactions-cripto/edit-cripto-transaction/edit-cripto-transaction.component';
import { SendTransactionaCriptoModalComponent } from './components/assigned-transactions-cripto/send-transactiona-cripto-modal/send-transactiona-cripto-modal.component';
import { AssignedTransactionsComponent } from './components/assigned-transactions/assigned-transactions.component';
import { EditTransactionModalComponent } from './components/assigned-transactions/edit-transaction-modal/edit-transaction-modal.component';
import { RejectTransactionModalComponent } from './components/assigned-transactions/reject-transaction-modal/reject-transaction-modal.component';
import { SendTransactionModalComponent } from './components/assigned-transactions/send-transaction-modal/send-transaction-modal.component';
import { BillingRecordComponent } from './components/billing-record/billing-record.component';
import { CalculatorCrytoComponent } from './components/calculator-cryto/calculator-cryto.component';
import { BalanceChangeComponent } from './components/calculator-cryto/components/balance-change/balance-change.component';
import { BeneficiaryComponent } from './components/calculator-cryto/components/beneficiary/beneficiary.component';
import { CalculatorCryptoComponent } from './components/calculator-cryto/components/calculator-crypto/calculator.component';
import { SummaryOrderComponent } from './components/calculator-cryto/components/summary-order/summary-order.component';
import { UsdtChangeComponent } from './components/calculator-cryto/components/usdt-change/usdt-change.component';
import { UsdtDestinationModalComponent } from './components/calculator-cryto/components/usdt-destination-modal/usdt-destination-modal.component';
import { CalculatorZelleComponent } from './components/calculator-zelle/calculator-zelle.component';
import { BeneficiaryZelleComponent } from './components/calculator-zelle/components/beneficiary-zelle/beneficiary-zelle.component';
import { CalculatorZelleCalComponent } from './components/calculator-zelle/components/calculator-zelle-cal/calculator-zelle-cal.component';
import { SummaryOrderZelleComponent } from './components/calculator-zelle/components/summary-order-zelle/summary-order-zelle.component';
import { ZelleChangeComponent } from './components/calculator-zelle/components/zelle-change/zelle-change.component';
import { CalculatorComponent } from './components/calculator/calculator.component';
import { CbpayCardexComponent } from './components/cbpay-cardex/cbpay-cardex.component';
import { CbpayViewWalletTransactionsComponent } from './components/cbpay-view-wallet-transactions/cbpay-view-wallet-transactions.component';
import { ChargeAccountComponent } from './components/charge-account/charge-account.component';
import { ComisionesBancariasComponent } from './components/comisiones-bancarias/comisiones-bancarias.component';
import { CompanyRegistrationComponent } from './components/company-registration/company-registration.component';
import { ComplianceListComponent } from './components/compliance-list/compliance-list.component';
import { ComplianceDialogComponent } from './components/compliance-user/compliance-dialog/compliance-dialog.component';
import { ComplianceUserComponent } from './components/compliance-user/compliance-user.component';
import { DataUpdateRequestComponent } from './components/data-update-request/data-update-request.component';
import { UpdateFieldInputComponent } from './components/data-update-request/components/update-field-input/update-field-input.component';
import { UpdateFieldFileComponent } from './components/data-update-request/components/update-field-file/update-field-file.component';
import { DocumentCameraCaptureComponent } from './components/data-update-request/components/document-camera-capture/document-camera-capture.component';
import { DataUpdateRequestsListComponent } from './components/data-update-requests-admin/data-update-requests-list/data-update-requests-list.component';
import { CreateDataUpdateRequestComponent } from './components/data-update-requests-admin/create-data-update-request/create-data-update-request.component';
import { DataUpdateRequestDetailComponent } from './components/data-update-requests-admin/data-update-request-detail/data-update-request-detail.component';
import { BulkCreateDataUpdateRequestComponent } from './components/data-update-requests-admin/bulk-create-data-update-request/bulk-create-data-update-request.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog-component/confirmation-dialog-component.component';
import { ConvertUsdtClpComponent } from './components/convert-usdt-clp/convert-usdt-clp.component';
import { ConvertUsdtVesComponent } from './components/convert-usdt-ves/convert-usdt-ves.component';
import { ComprarBolivaresComponent } from './components/comprar-bolivares/comprar-bolivares.component';
import { ConvertVesUsdtComponent } from './components/convert-ves-usdt/convert-ves-usdt.component';
import { CreateFormDialogComponent } from './components/create-transaction-dialog/create-transaction-dialog.component';
import { CreditLineDialogComponent } from './components/credit-line-dialog/credit-line-dialog.component';
import { CriptoHomeComponent } from './components/cripto-home/cripto-home.component';
import { CriptoRateComponent } from './components/cripto-rate/cripto-rate.component';
import { SetUsdtRateComponent } from './components/cripto-rate/set-usdt-rate/set-usdt-rate.component';
import { RailColombiaComponent } from './components/rail-colombia/rail-colombia.component';
import { RailPeruComponent } from './components/rail-peru/rail-peru.component';
import { RailColombiaCalculadoraComponent } from './components/rail-colombia-calculadora/rail-colombia-calculadora.component';
import { RailColombiaConfigComponent } from './components/rail-colombia-config/rail-colombia-config.component';
import { RailPeruConfigComponent } from './components/rail-peru-config/rail-peru-config.component';
import { RailPeruClientSimComponent } from './components/rail-peru-client-sim/rail-peru-client-sim.component';
import { RailClpCopConfigComponent } from './components/rail-clp-cop-config/rail-clp-cop-config.component';
import { RailVesCopConfigComponent } from './components/rail-ves-cop-config/rail-ves-cop-config.component';
import { RailVesPenConfigComponent } from './components/rail-ves-pen-config/rail-ves-pen-config.component';
import { RailClpPenConfigComponent } from './components/rail-clp-pen-config/rail-clp-pen-config.component';
import { RailColombiaClientSimComponent } from './components/rail-colombia-client-sim/rail-colombia-client-sim.component';
import { CuentasActivasVesComponent } from './components/cuentas-activas-ves/cuentas-activas-ves.component';
import { BancosActivosVesComponent } from './components/bancos-activos-ves/bancos-activos-ves.component';
import { ConnectedUsersComponent } from './components/connected-users/connected-users.component';
import { ConnectionAnalyticsComponent } from './components/connection-analytics/connection-analytics.component';
import { ConnectionHistoryComponent } from './components/connection-history/connection-history.component';
import { ConnectionDetailDialogComponent } from './components/connection-history/connection-detail-dialog/connection-detail-dialog.component';
import { MyConnectionsComponent } from './components/my-connections/my-connections.component';
import { PlatformMessagesInboxComponent } from './components/platform-messages-inbox/platform-messages-inbox.component';
import { PlatformMessagesSendComponent } from './components/platform-messages-send/platform-messages-send.component';
import { N58HomeComponent } from './components/n58-home/n58-home.component';
import { BancoPlazaHomeComponent } from './components/banco-plaza-home/banco-plaza-home.component';
import { BancoPlazaConsultaLiqModalComponent } from './components/banco-plaza-home/banco-plaza-consulta-liq-modal/banco-plaza-consulta-liq-modal.component';
import { BancoPlazaTransactionDetailModalComponent } from './components/banco-plaza-home/banco-plaza-transaction-detail-modal/banco-plaza-transaction-detail-modal.component';
import { VitaDashboardComponent } from './components/vita-dashboard/vita-dashboard.component';
import { VitaRegistroComponent } from './components/vita-registro/vita-registro.component';
import { VitaRegistroDetalleComponent } from './components/vita-registro/detalle-dialog/vita-registro-detalle.component';
import { VitaMovimientosComponent } from './components/vita-movimientos/vita-movimientos.component';
import { VitaMovimientoDetalleComponent } from './components/vita-movimientos/detalle-dialog/vita-movimiento-detalle.component';
import { AddCountryDialogComponent } from './components/vita-dashboard/add-country-dialog/add-country-dialog.component';
import { ConfirmDeactivateCountryDialogComponent } from './components/vita-dashboard/confirm-deactivate-country-dialog/confirm-deactivate-country-dialog.component';
import { SimulateRateDialogComponent } from './components/vita-dashboard/simulate-rate-dialog/simulate-rate-dialog.component';
import { DiagnosticsDialogComponent } from './components/vita-dashboard/diagnostics-dialog/diagnostics-dialog.component';
import { ConvertCurrencyDialogComponent } from './components/vita-dashboard/convert-currency-dialog/convert-currency-dialog.component';
import { VitaCalculatorDemoComponent } from './components/vita-calculator-demo/vita-calculator-demo.component';
import { AddVitaBeneficiarioDialogComponent } from './components/vita-calculator-demo/components/add-vita-beneficiario-dialog/add-vita-beneficiario-dialog.component';
import { VitaBeneficiarioDetailDialogComponent } from './components/vita-calculator-demo/components/vita-beneficiario-detail-dialog/vita-beneficiario-detail-dialog.component';
import { CompleteVitaBeneficiarioDialogComponent } from './components/vita-calculator-demo/components/complete-vita-beneficiario-dialog/complete-vita-beneficiario-dialog.component';
import { RecipientInternacionalComponent } from './components/recipient-internacional/recipient-internacional.component';
import { SelectDestinoDialogComponent } from './components/recipient-internacional/components/select-destino-dialog/select-destino-dialog.component';
import { AgentChatComponent } from './components/agent-chat/agent-chat.component';
import { AgentChatWidgetComponent } from './components/agent-chat-widget/agent-chat-widget.component';
import { DenounceListComponent } from './components/denounces/denounce-list/denounce-list.component';
import { DenounceDetailComponent } from './components/denounces/denounce-detail/denounce-detail.component';
import { DenounceAccessManagerComponent } from './components/denounces/denounce-access-manager/denounce-access-manager.component';
import { AdminFileUploaderComponent } from './components/denounces/shared/admin-file-uploader/admin-file-uploader.component';
import { AdminAttachmentViewerComponent } from './components/denounces/shared/attachment-viewer/attachment-viewer.component';
import { AdminAttachmentDialogComponent } from './components/denounces/shared/attachment-dialog/attachment-dialog.component';
import { CloseCaseDialogComponent } from './components/denounces/close-case-dialog/close-case-dialog.component';
import { DenounceMetricsPanelComponent } from './components/denounces/denounce-metrics-panel/denounce-metrics-panel.component';
import { NgChartsModule } from 'ng2-charts';
import { CreateCuentaBancariaVesModalComponent } from './components/bancos-activos-ves/create-cuenta-bancaria-ves-modal/create-cuenta-bancaria-ves-modal.component';
import { DetalleCajeroComponent } from './components/detalle-cajero/detalle-cajero.component';
import { DialogCambioComponent } from './components/dialog-cambio/dialog-cambio.component';
import { EditUserDataComponent } from './components/edit-user-data/edit-user-data.component';
import { FiatCalculatorComponent } from './components/fiat-calculator/fiat-calculator.component';
import { HomeRatesComponent } from './components/home-rates/home-rates.component';
import { RemittanceHubComponent } from './components/remittance-hub/remittance-hub.component';
import { GenerateCashClosingComponent } from './components/generate-rcash-closing/generate-cash-closing.component';
import { HoursOperationsComponent } from './components/hours-operations/hours-operations.component';
import { WalletsUsuariosComponent } from './components/wallets-usuarios/wallets-usuarios.component';
import { BinanceCentralizationsComponent } from './components/binance-centralizations/binance-centralizations.component';
import { BinanceLinkSubaccountsComponent } from './components/binance-link-subaccounts/binance-link-subaccounts.component';
import { CreateWalletModalComponent } from './components/wallets-usuarios/create-wallet-modal/create-wallet-modal.component';
import { ListPaysWalletsOperatorComponent } from './components/list-pays-wallets-operator/list-pays-wallets-operator.component';
import { LoadPaysBinanceComponent } from './components/load-pays-binance/load-pays-binance.component';
import { ReferenciasVesComponent } from './components/referencias-ves/referencias-ves.component';
import { ReferenciasVesAdminComponent } from './components/referencias-ves-admin/referencias-ves-admin.component';
import { ApproveReferenciaModalComponent } from './components/referencias-ves-admin/approve-referencia-modal/approve-referencia-modal.component';
import { RejectReferenciaModalComponent } from './components/referencias-ves-admin/reject-referencia-modal/reject-referencia-modal.component';
import { RegistrarReferenciaOperadorModalComponent } from './components/referencias-ves-admin/registrar-referencia-operador-modal/registrar-referencia-operador-modal.component';
import { EmparejarN58ModalComponent } from './components/referencias-ves-admin/emparejar-n58-modal/emparejar-n58-modal.component';
import { N58MontoMinModalComponent } from './components/n58-home/n58-monto-min-modal/n58-monto-min-modal.component';
import { N58CasosModalComponent } from './components/n58-home/n58-casos-modal/n58-casos-modal.component';
import { N58MovementDetailModalComponent } from './components/n58-home/n58-movement-detail-modal/n58-movement-detail-modal.component';
import { R4HomeComponent } from './components/r4-home/r4-home.component';
import { R4MontoMinModalComponent } from './components/r4-home/r4-monto-min-modal/r4-monto-min-modal.component';
import { BancoPlazaMontoMinModalComponent } from './components/banco-plaza-home/banco-plaza-monto-min-modal/banco-plaza-monto-min-modal.component';
import { ShinkansenMontoMaxModalComponent } from './components/withdraw-trx-list/shinkansen-monto-max-modal/shinkansen-monto-max-modal.component';
import { EditOperatorModalComponent } from './components/main-rates/edit-operator-modal.component';
import { EditUsdtVesModalComponent } from './components/main-rates/edit-usdt-ves-modal.component';
import { EditVesUsdtModalComponent } from './components/main-rates/edit-ves-usdt-modal.component';
import { MainRatesComponent } from './components/main-rates/main-rates.component';
import { ManualDepositComponent } from './components/manual-deposit/manual-deposit.component';
import { ManualTransactionHistoryDialogComponent } from './components/manual-transaction-history-dialog/manual-transaction-history-dialog.component';
import { ManualTransactionsComponent } from './components/manual-transactions/manual-transactions.component';
import { ManualXlsBciComponent } from './components/manual-xls-bci/manual-xls-bci.component';
import { MoneyOrderComponent } from './components/money-order/money-order.component';
import { MultipleMoneyOrderComponent } from './components/money-order/multiple-money-order/multiple-money-order.component';
import { OrdersListComponent } from './components/money-order/orders-list/orders-list.component';
import { PaymentInstructionComponent } from './components/money-order/payment-instruction/payment-instruction.component';
import { PaymentInstructionsMultipleComponent } from './components/money-order/payment-instructions-multiple/payment-instructions-multiple.component';
import { PaymentValidationComponent } from './components/money-order/payment-validation/payment-validation.component';
import { RecipientSelectComponent } from './components/money-order/recipient-select/recipient-select.component';
import { SingleMoneyOrderComponent } from './components/money-order/single-money-order/single-money-order.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { MarkupAlertModalComponent } from './components/navbar/markup-alert-modal.component';
import { EditMarkupUmbralModalComponent } from './components/main-rates/edit-markup-umbral-modal.component';
import { FranjasEditorComponent } from './components/main-rates/franjas-editor.component';
import { TramosUsdtEditorComponent } from './components/main-rates/tramos-usdt-editor.component';
import { PrecioBinanceBloqueComponent } from './components/main-rates/precio-binance-bloque.component';
import { DistanciaBloqueComponent } from './components/main-rates/distancia-bloque.component';
import { TramosDistanciaEditorComponent } from './components/main-rates/tramos-distancia-editor.component';
import { PagadorComplianceComponent } from './components/pagador-compliance/pagador-compliance.component';
import { RejectCompliancePagadorComponent } from './components/pagador-compliance/reject-compliance-pagador/reject-compliance-pagador.component';
import { CreatePayerComponent } from './components/payer/create-payer/create-payer.component';
import { ListPayerComponent } from './components/payer/list-payer/list-payer.component';
import { PayerInvitationsComponent } from './components/payer/payer-invitations/payer-invitations.component';
import { PayerComplianceListComponent } from './components/payer/payer-compliance-list/payer-compliance-list.component';
import { PayerComponent } from './components/payer/list-payer/payer/payer.component';
import { EditZelleTransactionComponent } from './components/pending-transactions-zelle/edit-zelle-transaction/edit-zelle-transaction.component';
import { PendingTransactionsZelleComponent } from './components/pending-transactions-zelle/pending-transactions-zelle.component';
import { SendTransactionsZelleModalComponent } from './components/pending-transactions-zelle/send-transactions-zelle-modal/send-transactions-zelle-modal.component';
import { RateUpdateTypeComponent } from './components/rate-update-type/rate-update-type.component';
import { RateValueCardComponent } from './components/rate-value-card/rate-value-card.component';
import { RatesComponent } from './components/rates/rates.component';
import { AddAccountCriptoComponent } from './components/recipient-cripto/components/add-account-cripto/add-account-cripto.component';
import { DialogBeneficiarioCriptoComponent } from './components/recipient-cripto/components/dialog-beneficiario-cripto/dialog-beneficiario-cripto.component';
import { RecipientCriptoCardComponent } from './components/recipient-cripto/components/recipient-cripto-list/recipient-cripto-card/recipient-cripto-card.component';
import { RecipientCriptoListComponent } from './components/recipient-cripto/components/recipient-cripto-list/recipient-cripto-list.component';
import { RecipientCriptoComponent } from './components/recipient-cripto/recipient-cripto.component';
import { AddBeneficiaryZelleComponent } from './components/recipient-zelle/components/add-beneficiary-zelle/add-beneficiary-zelle.component';
import { DialogBeneficiaryZelleComponent } from './components/recipient-zelle/components/dialog-beneficiary-zelle/dialog-beneficiary-zelle.component';
import { RecipientZelleCardComponent } from './components/recipient-zelle/components/recipient-zelle-list/recipient-zelle-card/recipient-zelle-card.component';
import { RecipientZelleListComponent } from './components/recipient-zelle/components/recipient-zelle-list/recipient-zelle-list.component';
import { RecipientZelleComponent } from './components/recipient-zelle/recipient-zelle.component';
import { RemittanceComponent } from './components/remittance/remittance.component';
import { ReportUsdtClpGeneralComponent } from './components/report-usdt-clp-general/report-usdt-clp-general.component';
import { ReportUsdtVesGeneralComponent } from './components/report-usdt-ves-general/report-usdt-ves-general.component';
import { TransactionsVesComponent } from './components/transactions-ves/transactions-ves.component';
import { ApproveSwapModalComponent } from './components/transactions-ves/approve-swap-modal/approve-swap-modal.component';
import { RejectSwapModalComponent } from './components/transactions-ves/reject-swap-modal/reject-swap-modal.component';
import { DetailTransactionModalComponent } from './components/transactions-ves/detail-transaction-modal/detail-transaction-modal.component';
import { SendUsdtComponent } from './components/send-usdt/send-usdt.component';
import { SetRatesParametersBolivaresComponent } from './components/set-rates-parameters-bolivares/set-rates-parameters-bolivares.component';
import { SetRatesParametersComponent } from './components/set-rates-parameters/set-rates-parameters.component';
import { SetRatesSalesParametersComponent } from './components/set-rates-sales-parameters/set-rates-sales-parameters.component';
import { StatusCajeroFiatComponent } from './components/status-cajero-fiat/status-cajero-fiat.component';
import { OperationsHistoryComponent } from './components/operations-history/operations-history.component';
import { ConciliacionAbonosComponent } from './components/conciliacion-abonos/conciliacion-abonos.component';
import { TransactionsDashboardComponent } from './components/transactions-dashboard/transactions-dashboard.component';
import { TransactionsVesCompletedComponent } from './components/transactions-ves-completed/transactions-ves-completed.component';
import { UnassignedTransactionsComponent } from './components/unassigned-transactions/unassigned-transactions.component';
import { UserHomeComponent } from './components/user-home/user-home.component';
import { ReferidosComponent } from './components/referidos/referidos.component';
import { ReferidosHomeComponent } from './components/referidos-home/referidos-home.component';
import { AsistenteClienteComponent } from './components/asistente-cliente/asistente-cliente.component';
import { ReferidosAdminComponent } from './components/referidos-admin/referidos-admin.component';
import { BonosComponent } from './components/bonos/bonos.component';
import { BonosAdminComponent } from './components/bonos-admin/bonos-admin.component';
import { MarketingAdminComponent } from './components/marketing-admin/marketing-admin.component';
import { RecordatorioAdminComponent } from './components/recordatorio-admin/recordatorio-admin.component';
import { ClientesApiAdminComponent } from './components/clientes-api-admin/clientes-api-admin.component';
import { ApiClienteComponent } from './components/api-cliente/api-cliente.component';
import { SeguimientoComponent } from './components/seguimiento/seguimiento.component';
import { GestionModalComponent } from './components/seguimiento/gestion-modal/gestion-modal.component';
import { ConfigModalComponent } from './components/seguimiento/config-modal/config-modal.component';
import { CrearCampanaModalComponent } from './components/bonos-admin/crear-campana-modal/crear-campana-modal.component';
import { CampanaTableroComponent } from './components/bonos-admin/campana-tablero/campana-tablero.component';
import { SetupMfaComponent } from './components/user-profile/setup-mfa/setup-mfa.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { DialogAssignPointsComponent } from './components/user-segmentation/dialog-assign-points/dialog-assign-points.component';
import { DialogSegmentationComponent } from './components/user-segmentation/dialog-segmentation/dialog-segmentation.component';
import { UserSegmentationComponent } from './components/user-segmentation/user-segmentation.component';
import { ValidateUserComponent } from './components/validate-user/validate-user.component';
import { WalletsCardexConciliatorComponent } from './components/wallets-cardex-conciliator/wallets-cardex-conciliator.component';
import { WithdrawAccountCardComponent } from './components/withdraw-accounts/withdraw-account-list/withdraw-account-card/withdraw-account-card.component';
import { WithdrawAccountListComponent } from './components/withdraw-accounts/withdraw-account-list/withdraw-account-list.component';
import { WithdrawAccountsComponent } from './components/withdraw-accounts/withdraw-accounts.component';
import { CalculatorWithdrawComponent } from './components/withdraw-balance/components/calculator-withdraw/calculator-withdraw.component';
import { WithdrawAccountsStepComponent } from './components/withdraw-balance/components/withdraw-accounts-step/withdraw-accounts-step.component';
import { WithdrawBalanceViewComponent } from './components/withdraw-balance/components/withdraw-balance-view/withdraw-balance-view.component';
import { WithdrawSummaryOrderComponent } from './components/withdraw-balance/components/withdraw-summary-order/withdraw-summary-order.component';
import { WithdrawBalanceComponent } from './components/withdraw-balance/withdraw-balance.component';
import { WithdrawBalanceVesComponent } from './components/withdraw-balance-ves/withdraw-balance-ves.component';
import { CalculatorWithdrawVesComponent } from './components/withdraw-balance-ves/components/calculator-withdraw-ves/calculator-withdraw-ves.component';
import { WithdrawAccountsStepVesComponent } from './components/withdraw-balance-ves/components/withdraw-accounts-step-ves/withdraw-accounts-step-ves.component';
import { WithdrawSummaryOrderVesComponent } from './components/withdraw-balance-ves/components/withdraw-summary-order-ves/withdraw-summary-order-ves.component';
import { RejectTransactionWithdrawModalComponent } from './components/withdraw-trx-list/reject-transaction-withdraw-modal/reject-transaction-withdraw-modal.component';
import { SendTransactionWithdrawModalComponent } from './components/withdraw-trx-list/send-transaction-withdraw-modal/send-transaction-withdraw-modal.component';
import { PayShinkansenModalComponent } from './components/withdraw-trx-list/pay-shinkansen-modal/pay-shinkansen-modal.component';
import { WithdrawTrxListComponent } from './components/withdraw-trx-list/withdraw-trx-list.component';
import { WithdrawTrxSentComponent } from './components/withdraw-trx-sent/withdraw-trx-sent.component';
import { ZelleHomeComponent } from './components/zelle-home/zelle-home.component';
import { SetZelleRateComponent } from './components/zelle-rate/set-zelle-rate/set-zelle-rate.component';
import { ZelleRateComponent } from './components/zelle-rate/zelle-rate.component';
import { RegistroBeneficiariosComponent } from './components/registro-beneficiarios/registro-beneficiarios.component';
import { ResponsableWalletComponent } from './components/responsable-wallet/responsable-wallet.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { HomeComponent } from './pages/home/home.component';
@NgModule({
  declarations: [
    AgentChatComponent,
    AgentChatWidgetComponent,
    HomeComponent,
    ManualXlsBciComponent,
    NavbarComponent,
    MarkupAlertModalComponent,
    EditMarkupUmbralModalComponent,
    FranjasEditorComponent,
    TramosUsdtEditorComponent,
    PrecioBinanceBloqueComponent,
    DistanciaBloqueComponent,
    TramosDistanciaEditorComponent,
    UserHomeComponent,
    ReferidosComponent,
    ReferidosHomeComponent,
    AsistenteClienteComponent,
    ReferidosAdminComponent,
    BonosComponent,
    BonosAdminComponent,
    MarketingAdminComponent,
    RecordatorioAdminComponent,
    ClientesApiAdminComponent,
    ApiClienteComponent,
    SeguimientoComponent,
    GestionModalComponent,
    ConfigModalComponent,
    CrearCampanaModalComponent,
    CampanaTableroComponent,
    ValidateUserComponent,
    UserProfileComponent,
    EditUserDataComponent,
    ComplianceListComponent,
    ComplianceUserComponent,
    DataUpdateRequestComponent,
    UpdateFieldInputComponent,
    UpdateFieldFileComponent,
    DocumentCameraCaptureComponent,
    DataUpdateRequestsListComponent,
    CreateDataUpdateRequestComponent,
    DataUpdateRequestDetailComponent,
    BulkCreateDataUpdateRequestComponent,
    AccountRecipientComponent,
    AccountComponent,
    AccountListComponent,
    MoneyOrderComponent,
    CalculatorComponent,
    SingleMoneyOrderComponent,
    PaymentInstructionComponent,
    PaymentValidationComponent,
    MultipleMoneyOrderComponent,
    RecipientSelectComponent,
    OrdersListComponent,
    CreatePayerComponent,
    PayerInvitationsComponent,
    PayerComplianceListComponent,
    PayerComponent,
    ListPayerComponent,
    PagadorComplianceComponent,
    AdminRateComponent,
    BinanceRateComponent,
    ManualRateComponent,
    SetValuesComponent,
    RatesComponent,
    AdminTransactionsComponent,
    DialogCambioComponent,
    RateValueCardComponent,
    AssignTransactionComponent,
    AssignedTransactionsComponent,
    SendTransactionModalComponent,
    RejectTransactionModalComponent,
    EditTransactionModalComponent,
    UnassignedTransactionsComponent,
    ComplianceDialogComponent,
    PaymentInstructionsMultipleComponent,
    ChargeAccountComponent,
    AccountDetailComponent,
    DialogBeneficiariosComponent,
    UsdtChangeComponent,
    BalanceChangeComponent,
    CalculatorCryptoComponent,
    BeneficiaryComponent,
    CalculatorCrytoComponent,
    SummaryOrderComponent,
    UsdtDestinationModalComponent,
    RecipientCriptoComponent,
    RecipientCriptoListComponent,
    RecipientCriptoCardComponent,
    AddAccountCriptoComponent,
    DialogBeneficiarioCriptoComponent,
    CriptoHomeComponent,
    CriptoRateComponent,
    RailColombiaComponent,
    RailPeruComponent,
    RailColombiaCalculadoraComponent,
    RailColombiaConfigComponent,
    RailPeruConfigComponent,
    RailPeruClientSimComponent,
    RailClpCopConfigComponent,
    RailVesCopConfigComponent,
    RailVesPenConfigComponent,
    RailClpPenConfigComponent,
    RailColombiaClientSimComponent,
    SetUsdtRateComponent,
    AssignedTransactionsCriptoComponent,
    EditCriptoTransactionComponent,
    SendTransactionaCriptoModalComponent,
    RejectCompliancePagadorComponent,
    HoursOperationsComponent,
    WalletsUsuariosComponent,
    BinanceCentralizationsComponent,
    BinanceLinkSubaccountsComponent,
    CreateWalletModalComponent,
    RateUpdateTypeComponent,
    ManualTransactionsComponent,
    CreateFormDialogComponent,
    ManualTransactionHistoryDialogComponent,
    RemittanceComponent,
    BillingRecordComponent,
    ManualDepositComponent,
    AccountsComponent,
    ConfirmationDialogComponent,
    AssignTrxDialogComponent,
    DepositosRetenidosDialogComponent,
    GenerateCashClosingComponent,
    SetRatesParametersComponent,
    AddWithdrawAccountsComponent,
    WithdrawAccountsComponent,
    WithdrawAccountListComponent,
    WithdrawAccountCardComponent,
    WithdrawBalanceComponent,
    CalculatorWithdrawComponent,
    WithdrawBalanceViewComponent,
    WithdrawAccountsStepComponent,
    WithdrawSummaryOrderComponent,
    WithdrawTrxListComponent,
    RejectTransactionWithdrawModalComponent,
    SendTransactionWithdrawModalComponent,
    PayShinkansenModalComponent,
    RecipientZelleComponent,
    AddBeneficiaryZelleComponent,
    DialogBeneficiaryZelleComponent,
    RecipientZelleListComponent,
    RecipientZelleCardComponent,
    SetRatesParametersBolivaresComponent,
    ZelleHomeComponent,
    ZelleChangeComponent,
    BeneficiaryZelleComponent,
    CalculatorZelleComponent,
    SummaryOrderZelleComponent,
    CalculatorZelleCalComponent,
    ZelleRateComponent,
    SetZelleRateComponent,
    PendingTransactionsZelleComponent,
    EditZelleTransactionComponent,
    SendTransactionsZelleModalComponent,
    CreditLineDialogComponent,
    OperationsHistoryComponent,
    ConciliacionAbonosComponent,
    TransactionsDashboardComponent,
    WithdrawTrxSentComponent,
    TransactionsVesCompletedComponent,
    UserSegmentationComponent,
    DialogSegmentationComponent,
    DialogAssignPointsComponent,
    SetupMfaComponent,
    CbpayComponent,
    CbpayViewWalletTransactionsComponent,
    CompanyRegistrationComponent,
    LoadPaysBinanceComponent,
    AdminWalletsComponent,
    AdminWhatsappOtpComponent,
    ListPaysWalletsOperatorComponent,
    ConvertUsdtClpComponent,
    ConvertUsdtVesComponent,
    ComprarBolivaresComponent,
    ConvertVesUsdtComponent,
    CbpayCardexComponent,
    SetRatesSalesParametersComponent,
    WalletsCardexConciliatorComponent,
    ReportUsdtClpGeneralComponent,
    ReportUsdtVesGeneralComponent,
    SendUsdtComponent,
    AdminWithdrawalsUsdtComponent,
    BinanceSearchByWalletComponent,
    ValidarWalletComponent,
    MainRatesComponent,
    EditOperatorModalComponent,
    EditUsdtVesModalComponent,
    EditVesUsdtModalComponent,
    FiatCalculatorComponent,
    RemittanceHubComponent,
    HomeRatesComponent,
    BeneficiaryBookComponent,
    DetalleCajeroComponent,
    StatusCajeroFiatComponent,
    ComisionesBancariasComponent,
    CuentasActivasVesComponent,
    BancosActivosVesComponent,
    CreateCuentaBancariaVesModalComponent,
    TransactionsVesComponent,
    ApproveSwapModalComponent,
    RejectSwapModalComponent,
    DetailTransactionModalComponent,
    WithdrawBalanceVesComponent,
    CalculatorWithdrawVesComponent,
    WithdrawAccountsStepVesComponent,
    WithdrawSummaryOrderVesComponent,
    ReferenciasVesComponent,
    ReferenciasVesAdminComponent,
    ApproveReferenciaModalComponent,
    RejectReferenciaModalComponent,
    RegistrarReferenciaOperadorModalComponent,
    EmparejarN58ModalComponent,
    ConnectedUsersComponent,
    ConnectionAnalyticsComponent,
    ConnectionHistoryComponent,
    ConnectionDetailDialogComponent,
    MyConnectionsComponent,
    PlatformMessagesInboxComponent,
    PlatformMessagesSendComponent,
    N58HomeComponent,
    N58MontoMinModalComponent,
    N58CasosModalComponent,
    R4HomeComponent,
    R4MontoMinModalComponent,
    N58MovementDetailModalComponent,
    BancoPlazaMontoMinModalComponent,
    ShinkansenMontoMaxModalComponent,
    BancoPlazaHomeComponent,
    BancoPlazaConsultaLiqModalComponent,
    BancoPlazaTransactionDetailModalComponent,
    VitaDashboardComponent,
    VitaRegistroComponent,
    VitaRegistroDetalleComponent,
    VitaMovimientosComponent,
    VitaMovimientoDetalleComponent,
    AddCountryDialogComponent,
    ConfirmDeactivateCountryDialogComponent,
    SimulateRateDialogComponent,
    DiagnosticsDialogComponent,
    ConvertCurrencyDialogComponent,
    VitaCalculatorDemoComponent,
    AddVitaBeneficiarioDialogComponent,
    CompleteVitaBeneficiarioDialogComponent,
    VitaBeneficiarioDetailDialogComponent,
    RecipientInternacionalComponent,
    SelectDestinoDialogComponent,
    DenounceListComponent,
    DenounceDetailComponent,
    DenounceAccessManagerComponent,
    AdminFileUploaderComponent,
    AdminAttachmentViewerComponent,
    AdminAttachmentDialogComponent,
    CloseCaseDialogComponent,
    DenounceMetricsPanelComponent,
    RegistroBeneficiariosComponent,
    ResponsableWalletComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DashboardRoutingModule,
    SharedModule,
    ClipboardModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    NgChartsModule,
  ],
  providers: [CurrencyPipe],
  exports: [CreateFormDialogComponent, ManualTransactionHistoryDialogComponent],
  entryComponents: [ConfirmationDialogComponent],
})
export class DashboardModule {}
